import type { ProjectType } from '@jira/platform__project-types/src/project-types.tsx';
import { SOFTWARE_PROJECT } from '@atlassian/jira-common-constants/src/project-types.tsx';

export const isJiraSoftware = (projectType: ProjectType | undefined) =>
	projectType && projectType === SOFTWARE_PROJECT;
